export default "__VITE_ASSET__Bq$gtGZr__"